import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _vm.isOpen ? _c('core-n20-dialog', {
    attrs: {
      "isOpen": _vm.isOpen,
      "width": "420"
    },
    on: {
      "close": function ($event) {
        return _vm.$emit('close');
      }
    }
  }, [_c('p', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v(_vm._s(_vm.$i18n_t('Common.multiFactorAuth.disableToken_p1')))]), _c('p', [_vm._v(_vm._s(_vm.$i18n_t('Common.multiFactorAuth.disableToken_p2')))]), _c(VTextField, {
    staticStyle: {
      "display": "block",
      "margin": "24px auto 0 auto !important",
      "max-width": "200px"
    },
    attrs: {
      "color": _vm.color,
      "outlined": "",
      "autofocus": "",
      "error": _vm.errorVerify,
      "label": "6-Digit Code",
      "maxlength": 6
    },
    on: {
      "keyup": function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        return _vm.handleCodeEntered.apply(null, arguments);
      }
    },
    model: {
      value: _vm.inputVerifyToken,
      callback: function ($$v) {
        _vm.inputVerifyToken = $$v;
      },
      expression: "inputVerifyToken"
    }
  }), _c(VBtn, {
    class: `v-btn-x mx-1 v-btn--rounded bg-rounded-button-${_vm.color}`,
    staticStyle: {
      "display": "block",
      "margin": "8px auto 0 auto !important"
    },
    attrs: {
      "color": _vm.color,
      "rounded": "",
      "text": "",
      "disabled": _vm.inputVerifyToken.length !== 6
    },
    on: {
      "click": _vm.handleCodeEntered
    }
  }, [_c(VIcon, {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("fal fa-arrow-right")]), _vm._v("\n      " + _vm._s(_vm.$i18n_t('Common.multiFactorAuth.disableToken_btn')) + "\n  ")], 1)], 1) : _vm._e();
};
var staticRenderFns = [];
export { render, staticRenderFns };